
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-05-19-remark-1",
      function () {
        return require("private-next-pages/blogs/2024-05-19-remark-1/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-05-19-remark-1"])
      });
    }
  